export default {
  setCurrentContainer(state, currentContainer) {
    state.currentContainer = currentContainer;
  },
  setDevice(state, device) {
    state.device = device;
  },

  setCheckoutBuilder(state, checkoutBuilder) {
    state.checkoutBuilder = checkoutBuilder;
  },

  setBackground(state, background) {
    state.background = background;
  },
  setComponents(state, components) {
    state.components = components;
  },

  setSnapshots(state, snapshots) {
    state.snapshots = snapshots;
  },
  setElement(state, element) {
    state.element = element;
  },
  setEditing(state, editing) {
    state.editing = editing;
  }
};
